<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import LayoutValidation from '@layouts/LayoutValidation.vue';
import BaseFileUpload from '@components/base/BaseFileUpload.vue';
import DocumentResult from '@views/DocumentResult.vue';

const { t } = useI18n();

const isDocumentValid = ref(false);

function validDocument(result) {
  isDocumentValid.value = result;
}
</script>

<template>
  <LayoutValidation
    icon="file-lines"
    :show-result="isDocumentValid"
    color="var(--color-feedback-success-400)"
  >
    <template #title>
      {{ t('validator.document.info.title') }}
    </template>

    <template #description>
      <p>{{ t('validator.document.info.description') }}</p>
    </template>

    <template #action>
      <BaseFileUpload
        :path="'/validators/certify.json'"
        :loading-text="t('validator.document.loading')"
        @document-validated="validDocument"
      />
    </template>

    <template #result>
      <DocumentResult />
    </template>
  </LayoutValidation>
</template>

<style lang="scss" module></style>
